if (navigator.userAgent.indexOf('Android') > 0) {
  $("body").addClass("android");
};
